import React from 'react';

import { forTemplate } from '@trello/i18n';

const format = forTemplate('notification_supplement');

interface ExportCompleteData {
  idExport: string;
  organization: {
    id: string;
  };
}

export const ExportCompleteSupplement: React.FunctionComponent<ExportCompleteData> = ({
  idExport,
  organization,
}) => {
  return (
    <a
      target="_blank"
      href={`/1/organization/${organization.id}/exports/${idExport}/download`}
    >
      {format('download-export')}
    </a>
  );
};
